module.exports = __webpack_public_path__ + "img/rewards.3fc04152.png";